/* ***************************************************************** */
/*                                                                   */
/* Licensed Materials - Property of Merative                         */
/*                                                                   */
/* (C) Copyright Merative Corp. 2025                                 */
/*                                                                   */
/* ***************************************************************** */
import {CommonFooter} from "../../../../../components/common/footers/Footer";
import React, { Fragment, useEffect, useRef } from "react";
import {
  areArraysEqual, force_array,
  get, isBackToTopScrollAvailable,
} from "../../../../../utils";
import {ModifySearchHeader} from "./components/ModifySearchHeader";
import CommonOverflowModalPopups from "../../../../../components/common-overflow-menu/CommonOverflowModalPopups";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import {DataTableContainer} from "./components/DataTableContainer";
import {getEnteralFormulaDetailsPromise} from "../../../../../services/neofaxPediatricsService";
import {fetchDetails, removeNutrientDetail} from "./redux/nutrient_details_redux";
import {SelectedItem} from "../../../../../components/common/SelectedItem";
import {makeDeleteSelectedFormulaThunk} from "../SearchPage/redux/formula_search_redux";
import {SectionTabsForNavigation, TitleHeader} from "../../../common/components";
import {NEOPED_URL, SECTION_TYPE_FORMULAS} from "../../../common/constants";
import {
    TITLE_ENTERAL_FORMULAS_NUTRIENT_DETAILS
} from "../../../../../components/common/constants";

export const NutrientDetailsPage = (props) => {

    const scrollingDivRef = useRef(null);
    const dispatch = useDispatch();
    const history = useHistory();
    const login_page = useSelector((state) => state.login_page);
    const nutrient_details = useSelector((state) => state.nutrient_details_page.data);
    const resultType = useSelector((state) => state.nutrient_details_page.resultType);
    const doc_ids = useSelector((state) => state.nutrient_details_page.docIds);
    const displayFormat = useSelector((state) => state.nutrient_details_page.displayFormat);


    const loc_search = get(props, "location.search", {});
    const saved_url_params = new URLSearchParams(loc_search);
    const docIdsFromUrl = saved_url_params.get("docIds");
    const docIdsFromUrlArray = force_array(docIdsFromUrl?.split(","));
    const displayFormatFromUrl = saved_url_params.get("displayFormat");
    const resultTypeFromUrl = saved_url_params.get("resultType");

   console.log("state", useSelector(state => console.log(state)));


    useEffect(() => {
        document.title = TITLE_ENTERAL_FORMULAS_NUTRIENT_DETAILS;
    }, []);

    useEffect(() => {
      const shouldMakeACall = docIdsFromUrl
        && (resultType !== resultTypeFromUrl
          || displayFormat !== displayFormatFromUrl
          || !areArraysEqual(docIdsFromUrlArray, force_array(doc_ids)));

      if (shouldMakeACall) {
            dispatch(fetchDetails({
                fetcher: () => getEnteralFormulaDetailsPromise({
                    result_type: resultTypeFromUrl,
                    docId: docIdsFromUrl,
                    displayFormat: displayFormatFromUrl,
                    login_page
                }),
                history,
                resultType: resultTypeFromUrl,
                displayFormat: displayFormatFromUrl,
                docIds: docIdsFromUrl.split(","),
                loginPage: login_page,
            }));
        }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, history, login_page, docIdsFromUrl, displayFormatFromUrl, resultTypeFromUrl]);


    const removeFormula = (docId) => {
        if(!doc_ids || doc_ids.length === 1|| !doc_ids.includes(docId)) {
            return;
        }
        dispatch(removeNutrientDetail({docId}));
        dispatch(makeDeleteSelectedFormulaThunk(docId));
        const updatedDocIds = doc_ids.filter((id) => id !== docId);
        const updatedDocIdsString = updatedDocIds.join(",");
        history.push(`${props.location.pathname}?docIds=${updatedDocIdsString}&displayFormat=${displayFormat}&resultType=${resultType}`);
    }

    const selectedFormulaNames = new Map();
    doc_ids.forEach((docId) => { // Changed from map to forEach
        const result = get(nutrient_details?.results, docId.toString(), {});
        if (result && result.docs && result.docs[0]) {
            const formulaName = result.docs[0].title;
            selectedFormulaNames.set(formulaName, docId);
        }
    });
    console.log("selectedFormulaNames", selectedFormulaNames);
    const modifySearchUrl = `${NEOPED_URL}?tab=${resultType}&section=${SECTION_TYPE_FORMULAS}`;

    return (
        <div ref={scrollingDivRef} className="main-container enteral-formula-nutrient-details-container">
            <div className="empty-container"></div>
            <div className="main-content">

                <div className="mdx-scroll-area mdx-scroll-area-ie" onScroll={() => isBackToTopScrollAvailable()}>
                  <SectionTabsForNavigation/>
                  <ModifySearchHeader modifySearchUrl={modifySearchUrl} />
                  <TitleHeader
                    subTitle="NeoFax® / Pediatrics"
                    mainTitle="Nutrient Details"
                  />
                    <div className="enteral-nutrient-details-search-section">
                        <div className="search-title">
                            <h5>Formula Search</h5>
                        </div>
                        <div className="enteral-nutrient-details-submitted-search">
                        {selectedFormulaNames && Array.from(selectedFormulaNames.entries()).map(([formulaName, docId], index) => (
                            <div className="enteral-nutrient-details-submitted-search-box enteral-nutrient-details-selected-item-container" key={index}>
                                <SelectedItem
                                    long_name={formulaName}
                                    className="formula-name"
                                    click_handler={() => removeFormula(docId)}
                                    shouldShowCloseIcon={selectedFormulaNames.size !== 1}
                                />
                            </div>
                        ))}
                        </div>
                    </div>

                    <div className="mdx-inner-content enteral-formula-nutrient-details-container">
                        {isEmpty(nutrient_details) ? (<Fragment/>) :
                          docIdsFromUrlArray.length > 3 ? (<div>Maximum of 3 formulas can be selected for comparison. Please remove a selected formula in order to add another formula.</div>) :
                                (<div className="table-container">
                                    <DataTableContainer
                                        data={nutrient_details}
                                        docIds={doc_ids || []}
                                        displayFormat={displayFormatFromUrl}
                                    />
                                </div>)}
                    </div>
                    <CommonOverflowModalPopups/>
                    <CommonFooter/>
                </div>
            </div>
        </div>

    );
};


    const isEmpty = (obj) => {
        return obj === undefined || obj === null || (typeof obj === 'object' && JSON.stringify(obj) === '{}');
    };
